import { render, staticRenderFns } from "./tag-filter.vue?vue&type=template&id=00a26a8b&scoped=true&"
import script from "./tag-filter.vue?vue&type=script&lang=js&"
export * from "./tag-filter.vue?vue&type=script&lang=js&"
import style0 from "./tag-filter.vue?vue&type=style&index=0&id=00a26a8b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a26a8b",
  null
  
)

export default component.exports